import {
    AudienceCategoryInfo,
    AudienceInterestInfo,
    AudienceInterestValue,
    AudienceRequest,
    AudienceSegmentValue,
    AudienceSize,
    BoxType,
    AudienceRequestUpdate
} from 'client/common/types';

export enum AudienceTabChoice {
    'Standard' = 'Standard',
    'Default' = 'Default',
    'Extended' = 'Extended'
}

export interface TargetingsProps {
    isSelected?: boolean;
    boxType?: BoxType;
    categories: AudienceCategoryInfo[];
    disabled: boolean;
    interests: AudienceInterestInfo[];
    request: AudienceRequest;
    onChange: (params: AudienceRequestUpdate) => Promise<void>;
    tab?: AudienceTabChoice.Standard | AudienceTabChoice.Extended;
}

export interface InterestsProps {
    disabled: boolean;
    onChange: (interest: AudienceInterestValue) => void;
    interests: AudienceInterestInfo[];
    selected: AudienceInterestValue;
}

export interface SegmentsProps {
    disabled: boolean;
    onChange: (interest: AudienceSegmentValue[]) => void;
    selected: AudienceSegmentValue[];
}

export interface SizeProps {
    onChange: (size: AudienceSize) => void;
    size: AudienceSize;
    handleUpdate: (sz: number, reset?: boolean) => Promise<void>;
    errorMsg?: string;
    disabled?: boolean;
}
